import React from 'react'

import { ModalRestrictor } from '@sketch/components'

import { NestedProjectItemGridView } from './NestedProjectItemGridView'
import { NestedProjectItemListView } from './NestedProjectItemListView'

import { StorageItemFragment } from '@sketch/gql-types'
import { RenderStorageItem } from '../../../storageItems/components'

interface NestedProjectItemProps {
  nestedProject: StorageItemFragment
  workspaceIdentifier: string
  onClick?: React.MouseEventHandler<HTMLElement>
  renderDropdown: RenderStorageItem<StorageItemFragment>
  disabledDrag: boolean
  presentation: 'grid' | 'list'
  selected?: boolean
  onSelectChange?: (selected: boolean) => void

  /* This property only applies to the grid presentation */
  showSelectionCheckbox?: boolean
}

export const NestedProjectItem: React.FCC<NestedProjectItemProps> = ({
  nestedProject,
  workspaceIdentifier,
  presentation,
  onClick,
  renderDropdown,
  disabledDrag,
  selected,
  onSelectChange,
  showSelectionCheckbox,
}) => {
  const Component =
    presentation === 'grid'
      ? NestedProjectItemGridView
      : NestedProjectItemListView

  return (
    <ModalRestrictor>
      <Component
        data-testid="nestedProject-item"
        nestedProject={nestedProject}
        workspaceIdentifier={workspaceIdentifier}
        renderDropdown={() => renderDropdown(nestedProject)}
        onClick={onClick}
        disabledDrag={disabledDrag}
        selected={selected}
        onSelectChange={onSelectChange}
        showSelectionCheckbox={showSelectionCheckbox}
      />
    </ModalRestrictor>
  )
}
